import { useNavigate } from 'react-router-dom';

import { Button, Container } from './styles';
import { useState } from 'react';
import { StatusModalConfirmClick } from '../StyledModalConfirmClick';
import { useUser } from '../../context/UserContext';

export const Header = () => {
  const { logout, user } = useUser();
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);

  const handleToNavigateTOLogin = () => {
    navigate('/login');
  };

  const handleToLogout = () => {
    setShowModal(true);
  };

  return (
    <Container>
      <div className="welcomeContainer"></div>
      {showModal && (
        <StatusModalConfirmClick
          type="question"
          text="Deseja realmente sair?"
          setModal={setShowModal}
          twoButtons={true}
          callActions={[logout, handleToNavigateTOLogin]}
        />
      )}
      <p>Olá, {user?.name?.split(' ')[0]}</p>
      <Button onClick={handleToLogout}>
        Você está com seu login ativo, clique aqui para SAIR.
      </Button>
    </Container>
  );
};
